import axios from 'axios';
import { Loading } from 'element-ui';
import { BzMsg, BzUser } from "js/helper";
const md5 = require('md5');
// 开发环境和真实环境切换，打包时注释
axios.defaults.baseURL = BzConfig.OsUrl;

export const BzAjax = {
    post(url, data) {
        return new Promise((resolve, reject) => {
            fetch(url, data).then(res => {
                if (res.Status == 0) {
                    resolve(res.Data);
                } else {
                    if (res.Status === 401) {
                        BzMsg.ShowErr(res.ErrorMessage);
                    } else {
                        BzMsg.ShowErr(res.ErrorMessage);
                    }
                }
            })
        })

    },
    get(url, data) {
        return new Promise((resolve, reject) => {
            fetch(url, data, 'get').then(res => {
                if (res.Status == 0) {
                    resolve(res.Data);
                } else {
                    if (res.Status === 401) {
                        BzMsg.ShowErr(res.ErrorMessage);
                    } else {
                        BzMsg.ShowErr(res.ErrorMessage);
                    }
                }
            })
        })

    },
};

function fetch(url, data = {}, type = 'post') {
    return new Promise((resolve, reject) => {
        if (url.indexOf("?") > 0) {
            url = url + "&token=" + getkey();
        } else {
            url = url + "?token=" + getkey();
        }

        let option = {
            url: url,
            method: type,
            validateStatus(status) {
                return (status >= 200 && status < 300) || status === 400;
            }
        };

        if (type.toLowerCase() === 'get') {
            option.params = data;
        } else {
            option.data = data;
        }

        //加载动画
        const loading = Loading.service({
            lock: true,
            text: '数据加载中, 请稍后',
            background: 'rgba(0, 0, 0, 0.5)'
        });

        axios(option).then((res) => {
            loading.close();
            if (res.status === 200) {
                if (res.data.Status === 401) {
                    // router.replace('login');
                    BzMsg.ShowErr("登陆状态失效，请退出重新登陆")
                    BzUser.deleteuser()

                }
                resolve(res.data);
            } else {
                console.error(res.data.msg || '参数错误');
                reject(res.data);
            }
        }).catch(function (err) {
            console.error('网络异常: ' + err);
            reject({ msg: '网络异常' });
            loading.close();
        });
    });
};
function getkey() {
    var users = BzUser.get();
    var loginid = users.sumirryname;
    var key = users.sumirrykey;
    var g = nokey();
    var sendkey = g + key;
    return g + md5(sendkey).substring(8, 24).toLowerCase() + loginid
};
function nokey() {
    function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }

    return (S4() + S4() + S4() + S4());
}




// WEBPACK FOOTER //
// ./src/assets/script/fetch.js